import { Grid, Paper, Stack, Typography } from "@mui/material";

import { Theme } from "../../../Style/Theme";
import CircularSpinner from "../../atoms/Spinner/CircularSpinner/CircularSpinner";
import { Text } from "../../atoms/Typography/Text/Text";
import {
  SummaryCardAmountText,
  SummaryCardDesciption,
  SummaryCardHeading,
  SummaryItemCardStyle,
  paperContent,
} from "./SummaryItemCard.Style";

export const SummaryItemCard = ({
  Image,
  heading,
  amount,
  description,
  status,
  marginRight,
  isLoading,
}) => {
  return (
    <Paper
      variant="White16"
      style={{ ...paperContent, marginRight: marginRight }}
    >
    {isLoading?  <CircularSpinner/>:<Grid
        container
        direction={"row"}
        style={SummaryItemCardStyle}
        alignItems={"center"}
        justifyItems={"center"}
      >
        <Grid item mr={"12px"}>
          <Image role="img" type="image" aria-label="cardimage" />
        </Grid>
        <Grid item>
          <Grid container direction={"column"}>
            <Grid item>
              <Typography
                color={Theme.palette.background.grayLight}
                sx={SummaryCardHeading}
              >
                {heading}
              </Typography>
            </Grid>
            <Grid item>
              <Stack direction={"row"}>
                <Typography
                  color={Theme.palette.background.grayDark}
                  sx={SummaryCardAmountText}
                >
                  {amount}
                </Typography>
                <Typography
                  color={Theme.palette.background.grayDark}
                  sx={SummaryCardDesciption}
                >
                  {description}
                </Typography>
              </Stack>
            </Grid>
          </Grid>
        </Grid>
      </Grid>}
    </Paper>
  );
};

export const SummaryItemCardType2 = ({
  Image,
  heading,
  amount,
  description,
  textAlignment,
  spacingForItems,
}) => {
  return (
    <Paper variant="White16" style={paperContent}>
      <Grid
        container
        direction={"row"}
        style={SummaryItemCardStyle}
        alignItems={"center"}
        justifyItems={"center"}
      >
        <Grid item mr={"12px"}>
          <Image />
        </Grid>
        <Grid item>
          <Grid container direction={textAlignment} spacing={spacingForItems}>
            <Grid item>
              <Text color={Theme.palette.background.grayDark} text={heading} />
            </Grid>
            <Grid item>
              <Stack direction={"row"}>
                <Typography
                  color={Theme.palette.background.grayDark}
                  sx={SummaryCardAmountText}
                >
                  {amount}
                </Typography>
                <Typography
                  color={Theme.palette.background.grayDark}
                  sx={SummaryCardDesciption}
                >
                  {description}
                </Typography>
              </Stack>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Paper>
  );
};
